import API from '@/org-app/api';
import { createApiAction, createGetAllAction } from '@/utils/ActionsUtils';

import * as types from './mutation-types';

const actions = {
  getUnreadAnnouncements: createGetAllAction(
    API.instance.getUnreadAnnouncements,
    types.UPDATE_ANNOUNCEMENTS_LIST,
    'messages.failedToGetAnnouncements',
    false,
  ),
  markAnnouncementAsRead: createApiAction(
    API.instance.markAnnoucementAsRead,
    types.MARK_ANNOUNCEMENT_AS_READ,
    'messages.failedToMarkAnnouncementAsRead',
  ),
};

export default actions;
